/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Widget_Week_ClosedInputs */

const en_us2_native_release_widget_week_closed = /** @type {(inputs: Native_Release_Widget_Week_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week complete`)
};

const pt_br2_native_release_widget_week_closed = /** @type {(inputs: Native_Release_Widget_Week_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana fechada`)
};

const pt_pt2_native_release_widget_week_closed = /** @type {(inputs: Native_Release_Widget_Week_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana fechada`)
};

/** @type {(inputs: Native_Release_Widget_Week_ClosedInputs) => LocalizedString} */
const es_419_native_release_widget_week_closed = en_us2_native_release_widget_week_closed;

/** @type {(inputs: Native_Release_Widget_Week_ClosedInputs) => LocalizedString} */
const fr_fr2_native_release_widget_week_closed = en_us2_native_release_widget_week_closed;

/** @type {(inputs: Native_Release_Widget_Week_ClosedInputs) => LocalizedString} */
const de_de2_native_release_widget_week_closed = en_us2_native_release_widget_week_closed;

/** @type {(inputs: Native_Release_Widget_Week_ClosedInputs) => LocalizedString} */
const it_it2_native_release_widget_week_closed = en_us2_native_release_widget_week_closed;

/**
* | output |
* | --- |
* | "Week complete" |
*
* @param {Native_Release_Widget_Week_ClosedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_week_closed = /** @type {((inputs?: Native_Release_Widget_Week_ClosedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Week_ClosedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_week_closed(inputs)
	if (locale === "es-419") return es_419_native_release_widget_week_closed(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_week_closed(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_week_closed(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_week_closed(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_week_closed(inputs)
	return en_us2_native_release_widget_week_closed(inputs)
});
export { native_release_widget_week_closed as "native-release.widget_week_closed" }